import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Typography,
    makeStyles,
} from "@material-ui/core"
import { ErrorOutline, ReportProblemOutlined } from "@material-ui/icons"

import useDialogMensagemStore from "../../stores/DialogMensagemStore"

const CORES = {
    error: { principal: "#e53935", fundoIcone: "#fdecea" },
    warning: { principal: "#f5a623", fundoIcone: "#fff6e5" },
}

const TITULOS = {
    error: "Ops, algo deu errado",
    warning: "Atenção",
}

const useStyles = makeStyles(theme => ({
    paper: {
        borderRadius: 16,
        padding: theme.spacing(1, 1, 0),
        maxWidth: 440,
    },
    conteudo: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        gap: theme.spacing(2),
        paddingTop: theme.spacing(3),
    },
    circuloIcone: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 64,
        height: 64,
        borderRadius: "50%",
        flexShrink: 0,
    },
    icone: {
        fontSize: 36,
    },
    titulo: {
        fontWeight: 600,
    },
    texto: {
        color: "rgba(0,0,0,0.7)",
        // Mensagens de API podem vir longas e sem espaços (JSON, URL); sem isto
        // elas estouram a largura do dialog em vez de quebrar.
        overflowWrap: "anywhere",
    },
    acoes: {
        justifyContent: "center",
        padding: theme.spacing(1, 3, 3),
    },
    botao: {
        borderRadius: 25,
        textTransform: "none",
        fontWeight: 600,
        minWidth: 140,
        color: "white",
    },
}))

export default function DialogMensagem() {
    const classes = useStyles()
    const mensagem = useDialogMensagemStore(s => s.fila[0])
    const fecharAtual = useDialogMensagemStore(s => s.fecharAtual)

    const severidade = mensagem?.severidade || "error"
    const cores = CORES[severidade]
    const Icone = severidade === "warning" ? ReportProblemOutlined : ErrorOutline

    return (
        <Dialog
            open={Boolean(mensagem)}
            onClose={fecharAtual}
            maxWidth="xs"
            fullWidth
            classes={{ paper: classes.paper }}
            aria-labelledby="dialog-mensagem-titulo"
        >
            <DialogContent className={classes.conteudo}>
                <div
                    className={classes.circuloIcone}
                    style={{ backgroundColor: cores.fundoIcone }}
                >
                    <Icone className={classes.icone} style={{ color: cores.principal }} />
                </div>
                <Typography
                    variant="h6"
                    id="dialog-mensagem-titulo"
                    className={classes.titulo}
                >
                    {TITULOS[severidade]}
                </Typography>
                <Typography variant="body1" className={classes.texto}>
                    {mensagem?.texto}
                </Typography>
            </DialogContent>
            <DialogActions className={classes.acoes}>
                <Button
                    variant="contained"
                    disableElevation
                    autoFocus
                    onClick={fecharAtual}
                    className={classes.botao}
                    style={{ backgroundColor: cores.principal }}
                >
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    )
}
